import { asyncRoutes, constantRoutes } from "@/router";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
  menuRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  // 根据路由表动态生成导航菜单
  SET_MENUROUTES: (state, menuRoutes) => {
    state.menuRoutes = menuRoutes.filter(i => !i.hidden).sort((a, b) => a.meta.sort - b.meta.sort);
  }
};

const actions = {
  generateRoutes({ commit, dispatch, state }, roles) {
    return new Promise(resolve => {
      let accessedRoutes;
      // 如果用户权限是admin，则路由全部显示
      if (roles.includes("admin")) {
        accessedRoutes = asyncRoutes || [];
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      }
      commit("SET_ROUTES", accessedRoutes);
      dispatch("setMenuRoutes", state.routes);
      resolve(accessedRoutes);
    });
  },
  setMenuRoutes({ commit }, value) {
    commit("SET_MENUROUTES", value);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
